
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.3319',
  depVersions: {
  "customer-portal-app": "static-1.3319",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.507",
  "data-fetching-client": "static-1.10071",
  "emoji-mart": "static-3.6",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.26412",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6014",
  "hs-test-utils": "static-1.8463",
  "hub-http": "static-1.6634",
  "hub-http-shared-msw-handlers": "static-1.10821",
  "hubspot-dlb": "static-2.1911",
  "hubspot-prosemirror": "static-1.19191",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11917",
  "I18n": "static-7.1696",
  "immutable": "static-2.88",
  "jasmine-runner": "static-1.6875",
  "payment-link-components": "static-1.24358",
  "portals-platform-bend-plugin": "static-1.26",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7598",
  "quartz-core": "static-1.6817",
  "quartz-i18n": "static-1.1273",
  "react": "static-7.202",
  "react-colorpicker": "static-2.10637",
  "react-dlb": "static-1.92",
  "react-utils": "static-2.5632",
  "reselect": "static-3.15",
  "rich-text-lib": "static-1.20481",
  "transmute": "static-2.97",
  "ui-addon-upgrades": "static-9.18516",
  "ui-components-test-utils": "static-1.6054",
  "UIComponents": "static-3.8863",
  "foundations-assets": "static-1.5309",
  "foundations-components": "static-1.8671",
  "foundations-theming": "static-1.4906",
  "foundations-theming-specialty": "static-1.2622",
  "framer-motion": "static-1.83",
  "metrics-js": "static-1.9990",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1642",
  "quartz-config": "static-1.1376",
  "quartz-routing": "static-1.1028",
  "quick-fetch": "static-1.4200",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.17158",
  "rpc-client-utils": "static-1.5095",
  "sanitize-text": "static-1.8581",
  "styled-components": "static-2.100",
  "tanstack-table": "static-1.65",
  "ui-addon-draggable": "static-3.5172",
  "ui-addon-react-router-dom": "static-1.9954",
  "usage-tracker": "static-1.7739",
  "usage-tracker-anonymous": "static-1.6156",
  "usage-tracker-core": "static-1.7589",
  "video-components-external": "static-1.12345",
  "apollo-stack-hubspot": "static-3.94",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3875",
  "quartz-webpack": "static-1.3822",
  "bend-plugin-quartz-routing": "static-1.676",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.92",
  "customer-data-objects": "static-1.8118",
  "frontend-preferences-client": "static-1.8343",
  "laboratory-lib": "static-3.7575",
  "onboarding-scopes": "static-1.6877",
  "seat-types-lib": "static-1.958",
  "ui-addon-opt": "static-4.8808",
  "HeadJS": "static-2.815",
  "hs-test-utils-bend-plugin": "static-1.3574",
  "msw": "static-1.102",
  "msw-config": "static-1.23",
  "testing-library": "static-1.163",
  "hs-locale-management": "static-1.370",
  "ts-schema": "static-1.4370",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8352",
  "content-media-capture": "static-1.5692",
  "cssUtils": "static-1.1047",
  "customer-data-ui-utilities": "static-1.10258",
  "file-manager-components": "static-1.24757",
  "HubStyle": "static-2.12224",
  "knowledge-content-types": "static-1.8709",
  "PatternValidationJS": "static-1.3311",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.514",
  "ui-addon-emoji-picker": "static-1.10291",
  "ui-addon-i18n": "static-1.11571",
  "ui-business-units-lib": "static-1.9520",
  "ui-shepherd-react": "static-3.10699",
  "video-data-lib": "static-1.36003",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4733",
  "commerce-tours-lib": "static-1.6792",
  "customer-data-properties": "static-1.52909",
  "getting-started-shared-tasks": "static-1.19477",
  "growth-onboarding-reliability": "static-1.5507",
  "onboarding-tours": "static-1.17315",
  "reference-resolvers-lite": "static-1.8530",
  "sales-checkout-service-client": "static-1.3954",
  "ui-addon-iframeable": "static-1.9501",
  "user-context": "static-1.5480",
  "bender-build-tools": "static-1.3518",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.900",
  "hubspotter-http": "static-1.4937",
  "icons": "static-2.699",
  "mobile-manifest-mixins": "static-1.598",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1.588",
  "quartz-auth": "static-1.1273",
  "quartz-head": "static-1.1263",
  "quartz-test": "static-1.1273",
  "quartz-tracking": "static-1.977",
  "trellis-components": "static-1.2989",
  "ui-fonts": "static-1.1179",
  "usage-tracker-container": "static-1.7729",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9849",
  "data-token-picker": "static-1.17053",
  "FileManagerLib": "static-1.40397",
  "property-translator": "static-1.5804",
  "merchandise-lib": "static-1.283",
  "purchase-motions-components": "static-1.6572",
  "SharedI18nStrings": "static-1.186",
  "foundations-components-test-utils": "static-1.6154",
  "react-create-root-preference": "static-1.94",
  "react-select-plus": "static-1.117",
  "react-virtualized": "static-2.111",
  "ui-images": "static-2.1269",
  "bend-plugin-foundations-components": "static-1.4940",
  "floating-ui": "static-1.67",
  "react-aria": "static-1.76",
  "trellis-assets": "static-1.2970",
  "bend-plugin-foundations-theming": "static-1.3389",
  "foundations-theming-base": "static-1.3891",
  "stylex": "static-1.45",
  "pdf-js": "static-2.49",
  "interframe": "static-3.5165",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.6153",
  "opentelemetry-fe-types": "static-1.213",
  "web-vitals": "static-1.18",
  "bend-plugin-chirp-manifest": "static-1.505",
  "chirp-fetch": "static-1.2326",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4898",
  "react-flip-move": "static-1.82",
  "apollo-link-hub-http": "static-2.5022",
  "content-media-composition-data-lib": "static-1.13496",
  "content-media-compositions": "static-2.17503",
  "idb-keyval": "static-1.54",
  "immer": "static-1.104",
  "immerable": "static-1.4566",
  "magpie-lib": "static-1.5861",
  "magpie-types": "static-1.5321",
  "media-bridge-lib": "static-1.19568",
  "inbound-db-properties-service-client": "static-1.4117",
  "superstore": "static-1.5183",
  "feedback-loader": "static-1.29987",
  "ai-components-ui-library": "static-1.9937",
  "ui-addon-video-player": "static-1.9057",
  "ui-coaching-tips": "static-1.29519",
  "ContentUtils": "static-1.69357",
  "fix-webm-duration": "static-1.33",
  "notification-sounds": "static-1.4851",
  "sassPrefix": "static-1.313",
  "react-dnd-compat": "static-1.5035",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.2023",
  "copilot-toolkit": "static-1.12060",
  "poll-commands": "static-1.3899",
  "atom": "static-1.5502",
  "avatar-components": "static-1.2908",
  "navigation-messaging": "static-1.8404",
  "redux-thunk": "static-2.83",
  "reference-resolvers": "static-1.8602",
  "commerce-products-lib": "static-1.10779",
  "crm-message-bus": "static-1.44001",
  "growth-data-modal": "static-1.6061",
  "hubspot-apollo-client": "static-1.5302",
  "onboarding-tours-client": "static-1.5530",
  "batch-promise": "static-1.1971",
  "calling-global-api": "static-1.66043",
  "calling-internal-common": "static-1.31749",
  "calling-lifecycle-internal": "static-1.67425",
  "calling-lifecycle-messages": "static-1.59718",
  "conditional-properties-service-client": "static-1.4090",
  "crm-index-visualization-core": "static-1.4691",
  "crm-links": "static-1.6730",
  "crm-pipelines-api-client-types": "static-1.4421",
  "customer-data-objects-ui-components": "static-1.13455",
  "customer-data-properties-shared-msw-handlers": "static-1.10148",
  "customer-data-property-utils": "static-1.8469",
  "external-options-client-types": "static-1.4419",
  "formula-editor": "static-1.14944",
  "framework-data-schema-resolvers": "static-1.7317",
  "google-libphonenumber": "static-1.48",
  "hs-resources": "static-1.622",
  "inbound-db-meta-service-client": "static-1.3748",
  "inbounddb-objects-service-types": "static-1.4500",
  "meetings-icalendar-utils-lib": "static-1.1062",
  "multi-currency-client-types": "static-1.3986",
  "object-builder-ui-client": "static-1.49941",
  "pipeline-validation-client-types": "static-1.4258",
  "property-value-citations": "static-1.3523",
  "pulse": "static-1.1066",
  "smart-data-capture-core": "static-1.373",
  "smart-property-lib": "static-1.8539",
  "tiered-pricing": "static-1.2156",
  "topics-actions-lib": "static-1.600",
  "trial-components-library": "static-1.14300",
  "ui-addon-form-validation": "static-1.11341",
  "zustand": "static-1.88",
  "growth-onboarding-confetti": "static-1.3488",
  "growth-onboarding-next-action-utils": "static-1.2901",
  "navigation-components": "static-1.19077",
  "onboarding-tours-utils": "static-1.1382",
  "ui-shepherd-tracker": "static-1.8080",
  "ui-universal-auth": "static-1.9635",
  "getting-started-shared-tasks-store": "static-1.18595",
  "beacon-keepalive-queue": "static-1.125",
  "opentelemetry-web": "static-1.20",
  "hubspotter-http-shared-msw-handlers": "static-1.10819",
  "usage-tracker-session-replay": "static-1.5425",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.14",
  "trellis-theming": "static-1.1410",
  "tanstack-virtual": "static-1.42",
  "audio-components": "static-1.6501",
  "FileManagerCore": "static-1.40256",
  "FileManagerImages": "static-1.37908",
  "video-components": "static-1.14347",
  "foundations-components-legacy": "static-1.1696",
  "purchase-motions-api": "static-1.6575",
  "signup-constants": "static-1.19854",
  "signup-ui-url-generator": "static-2.8484",
  "stylex-utils": "static-1.164",
  "usage-tracker-public": "static-1.7550",
  "reactive-lib": "static-1.1148",
  "simple-logging-lib": "static-1.3476",
  "nudge-client-utils": "static-1.3334",
  "chatspot-core": "static-1.23562",
  "growth-onboarding-feedback-components": "static-1.7007",
  "cms-field-types": "static-1.5237",
  "content-icons-ui": "static-1.2418",
  "integrations-lib": "static-1.17315",
  "underscore": "static-1.8",
  "breeze-engine-chat-components": "static-1.1001",
  "breeze-engine-core": "static-1.1301",
  "ably": "static-2.2",
  "highlight.js": "static-1.89",
  "markdown-it": "static-1.6",
  "nav-meta": "static-1.30714",
  "commerce-permissions": "static-1.1204",
  "customer-data-tracking": "static-1.7297",
  "products-iframe-lib": "static-1.8817",
  "products-ui-components-shared-msw-handlers": "static-1.11203",
  "restore-request-side-panel-lib": "static-1.1933",
  "onboarding-data-sync-lib": "static-1.2765",
  "hubspot-apollo-cache": "static-1.761",
  "calling-error-reporting": "static-1.31756",
  "shared-worker-versioning": "static-1.11465",
  "calling-usage-tracker": "static-1.6959",
  "voice-sms-access-library": "static-1.2335",
  "conversations-skeleton-state": "static-1.7602",
  "crm-index-associations-lib": "static-1.6873",
  "framework-data-schema-quick-fetch": "static-1.7222",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10904",
  "redux-toolkit": "static-1.81",
  "sales-views-client-types": "static-1.4683",
  "location-customization-utils-lib": "static-1.10331",
  "bark-lib": "static-1.16956",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.105",
  "crm-properties-common-lib": "static-1.6313",
  "react-codemirror": "static-1.11065",
  "fdsr-migration-layer": "static-1.436",
  "framework-builder-read-service-client": "static-1.4297",
  "persist-promise": "static-1.4128",
  "event-emitter": "static-1.1384",
  "bend-plugin-pulse": "static-1.569",
  "fast-json-patch": "static-1.73",
  "data-agent-kit": "static-1.822",
  "fsm": "static-1.4180",
  "policy-lib": "static-1.7230",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10967",
  "embedded-academy-lib": "static-1.15870",
  "hubs-service-types": "static-1.1690",
  "salesImages": "static-1.682",
  "growth-onboarding-next-action-components": "static-1.2929",
  "user-context-client": "static-1.4934",
  "nest": "static-1.661",
  "unified-auth-core-lib": "static-1.1431",
  "amplitude-session-replay-browser": "static-1.60",
  "breeze-artifacts-sdk": "static-1.710",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.64",
  "urlinator": "static-1.4941",
  "video-embed": "static-1.36837",
  "social-insights-client-types": "static-1.22853",
  "nudge-custom-function-registry": "static-1.3091",
  "nudge-renderer-utils": "static-1.3410",
  "whisper-core-api": "static-1.7552",
  "flux-actions": "static-1.380",
  "integrations-error-boundary-lib": "static-1.14730",
  "integrations-tracking-lib": "static-1.6036",
  "native-integrations-shared-strings": "static-1.8187",
  "redux-observable": "static-1.78",
  "ReduxMessenger": "static-2.10796",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.1149",
  "InboxConnectUtils": "static-4.15762",
  "meetings-connect-utils-lib": "static-1.8041",
  "calling-orchestration-schema": "static-1.37112",
  "crm-record-cards-service-types": "static-1.3839",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16582",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.114",
  "trellis-story-utils": "static-1.4927",
  "storybook-react": "static-1.43",
  "academy-common-lib": "static-1.15330",
  "outpost": "static-1.4558",
  "universal-page-editor-lib": "static-1.3434",
  "adobe-sign-auth-lib": "static-1.677",
  "ads-unified-auth-lib": "static-1.1784",
  "custom-vendor-connection-lib": "static-1.199",
  "google-sheets-integration-lib": "static-1.1245",
  "microsoft-drive-auth-lib": "static-1.406",
  "surveymonkey-integration-lib": "static-1.773",
  "slack-ui-library": "static-1.10822",
  "hub-http-contrib": "static-1.3453",
  "ui-addon-sales-email": "static-1.5627",
  "academy-service-client": "static-1.4118",
  "croppie": "static-2.10",
  "final-form": "static-1.82",
  "SafeStorage": "static-1.4818",
  "trellis-ecosystem": "static-1.7781",
  "wootric-nps": "static-1.7271",
  "marketplace-ui-apps-core": "static-1.19500",
  "marketplace-ui-common": "static-1.20968",
  "developer-experience-shared-components": "static-1.10963",
  "immutable-less": "static-1.5075",
  "marketplace-ui-client-types": "static-1.18375",
  "ui-addon-integrations-directory-panel": "static-2.8389",
  "ui-extensibility-client-types": "static-1.4341",
  "ai-settings-ui-library": "static-1.8505",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1450",
  "apps-service-types": "static-1.4072",
  "oauth-service-types": "static-1.4597",
  "settings-ui-lib": "static-1.12955",
  "simple-data-table": "static-1.3744"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.3319",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.507",
  "data-fetching-client": "/data-fetching-client/static-1.10071",
  "emoji-mart": "/emoji-mart/static-3.6",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.26412",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6014",
  "hs-test-utils": "/hs-test-utils/static-1.8463",
  "hub-http": "/hub-http/static-1.6634",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10821",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19191",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11917",
  "I18n": "/I18n/static-7.1696",
  "immutable": "/immutable/static-2.88",
  "jasmine-runner": "/jasmine-runner/static-1.6875",
  "payment-link-components": "/payment-link-components/static-1.24358",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.26",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7598",
  "quartz-core": "/quartz-core/static-1.6817",
  "quartz-i18n": "/quartz-i18n/static-1.1273",
  "react": "/react/static-7.202",
  "react-colorpicker": "/react-colorpicker/static-2.10637",
  "react-dlb": "/react-dlb/static-1.92",
  "react-utils": "/react-utils/static-2.5632",
  "reselect": "/reselect/static-3.15",
  "rich-text-lib": "/rich-text-lib/static-1.20481",
  "transmute": "/transmute/static-2.97",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18516",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6054",
  "UIComponents": "/UIComponents/static-3.8863",
  "foundations-assets": "/foundations-assets/static-1.5309",
  "foundations-components": "/foundations-components/static-1.8671",
  "foundations-theming": "/foundations-theming/static-1.4906",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2622",
  "framer-motion": "/framer-motion/static-1.83",
  "metrics-js": "/metrics-js/static-1.9990",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1642",
  "quartz-config": "/quartz-config/static-1.1376",
  "quartz-routing": "/quartz-routing/static-1.1028",
  "quick-fetch": "/quick-fetch/static-1.4200",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.17158",
  "rpc-client-utils": "/rpc-client-utils/static-1.5095",
  "sanitize-text": "/sanitize-text/static-1.8581",
  "styled-components": "/styled-components/static-2.100",
  "tanstack-table": "/tanstack-table/static-1.65",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5172",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9954",
  "usage-tracker": "/usage-tracker/static-1.7739",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6156",
  "usage-tracker-core": "/usage-tracker-core/static-1.7589",
  "video-components-external": "/video-components-external/static-1.12345",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3875",
  "quartz-webpack": "/quartz-webpack/static-1.3822",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.676",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.92",
  "customer-data-objects": "/customer-data-objects/static-1.8118",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8343",
  "laboratory-lib": "/laboratory-lib/static-3.7575",
  "onboarding-scopes": "/onboarding-scopes/static-1.6877",
  "seat-types-lib": "/seat-types-lib/static-1.958",
  "ui-addon-opt": "/ui-addon-opt/static-4.8808",
  "HeadJS": "/HeadJS/static-2.815",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3574",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.23",
  "testing-library": "/testing-library/static-1.163",
  "hs-locale-management": "/hs-locale-management/static-1.370",
  "ts-schema": "/ts-schema/static-1.4370",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8352",
  "content-media-capture": "/content-media-capture/static-1.5692",
  "cssUtils": "/cssUtils/static-1.1047",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10258",
  "file-manager-components": "/file-manager-components/static-1.24757",
  "HubStyle": "/HubStyle/static-2.12224",
  "knowledge-content-types": "/knowledge-content-types/static-1.8709",
  "PatternValidationJS": "/PatternValidationJS/static-1.3311",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.514",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10291",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11571",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9520",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10699",
  "video-data-lib": "/video-data-lib/static-1.36003",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4733",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6792",
  "customer-data-properties": "/customer-data-properties/static-1.52909",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19477",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5507",
  "onboarding-tours": "/onboarding-tours/static-1.17315",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8530",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3954",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9501",
  "user-context": "/user-context/static-1.5480",
  "bender-build-tools": "/bender-build-tools/static-1.3518",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.900",
  "hubspotter-http": "/hubspotter-http/static-1.4937",
  "icons": "/icons/static-2.699",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.598",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.588",
  "quartz-auth": "/quartz-auth/static-1.1273",
  "quartz-head": "/quartz-head/static-1.1263",
  "quartz-test": "/quartz-test/static-1.1273",
  "quartz-tracking": "/quartz-tracking/static-1.977",
  "trellis-components": "/trellis-components/static-1.2989",
  "ui-fonts": "/ui-fonts/static-1.1179",
  "usage-tracker-container": "/usage-tracker-container/static-1.7729",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9849",
  "data-token-picker": "/data-token-picker/static-1.17053",
  "FileManagerLib": "/FileManagerLib/static-1.40397",
  "property-translator": "/property-translator/static-1.5804",
  "merchandise-lib": "/merchandise-lib/static-1.283",
  "purchase-motions-components": "/purchase-motions-components/static-1.6572",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6154",
  "react-create-root-preference": "/react-create-root-preference/static-1.94",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-virtualized": "/react-virtualized/static-2.111",
  "ui-images": "/ui-images/static-2.1269",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4940",
  "floating-ui": "/floating-ui/static-1.67",
  "react-aria": "/react-aria/static-1.76",
  "trellis-assets": "/trellis-assets/static-1.2970",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3389",
  "foundations-theming-base": "/foundations-theming-base/static-1.3891",
  "stylex": "/stylex/static-1.45",
  "pdf-js": "/pdf-js/static-2.49",
  "interframe": "/interframe/static-3.5165",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6153",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.213",
  "web-vitals": "/web-vitals/static-1.18",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.505",
  "chirp-fetch": "/chirp-fetch/static-1.2326",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4898",
  "react-flip-move": "/react-flip-move/static-1.82",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5022",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13496",
  "content-media-compositions": "/content-media-compositions/static-2.17503",
  "idb-keyval": "/idb-keyval/static-1.54",
  "immer": "/immer/static-1.104",
  "immerable": "/immerable/static-1.4566",
  "magpie-lib": "/magpie-lib/static-1.5861",
  "magpie-types": "/magpie-types/static-1.5321",
  "media-bridge-lib": "/media-bridge-lib/static-1.19568",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4117",
  "superstore": "/superstore/static-1.5183",
  "feedback-loader": "/feedback-loader/static-1.29987",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9937",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29519",
  "ContentUtils": "/ContentUtils/static-1.69357",
  "fix-webm-duration": "/fix-webm-duration/static-1.33",
  "notification-sounds": "/notification-sounds/static-1.4851",
  "sassPrefix": "/sassPrefix/static-1.313",
  "react-dnd-compat": "/react-dnd-compat/static-1.5035",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2023",
  "copilot-toolkit": "/copilot-toolkit/static-1.12060",
  "poll-commands": "/poll-commands/static-1.3899",
  "atom": "/atom/static-1.5502",
  "avatar-components": "/avatar-components/static-1.2908",
  "navigation-messaging": "/navigation-messaging/static-1.8404",
  "redux-thunk": "/redux-thunk/static-2.83",
  "reference-resolvers": "/reference-resolvers/static-1.8602",
  "commerce-products-lib": "/commerce-products-lib/static-1.10779",
  "crm-message-bus": "/crm-message-bus/static-1.44001",
  "growth-data-modal": "/growth-data-modal/static-1.6061",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5302",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5530",
  "batch-promise": "/batch-promise/static-1.1971",
  "calling-global-api": "/calling-global-api/static-1.66043",
  "calling-internal-common": "/calling-internal-common/static-1.31749",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67425",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59718",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4090",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4691",
  "crm-links": "/crm-links/static-1.6730",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4421",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13455",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10148",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8469",
  "external-options-client-types": "/external-options-client-types/static-1.4419",
  "formula-editor": "/formula-editor/static-1.14944",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7317",
  "google-libphonenumber": "/google-libphonenumber/static-1.48",
  "hs-resources": "/hs-resources/static-1.622",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3748",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4500",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1062",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3986",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49941",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4258",
  "property-value-citations": "/property-value-citations/static-1.3523",
  "pulse": "/pulse/static-1.1066",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.373",
  "smart-property-lib": "/smart-property-lib/static-1.8539",
  "tiered-pricing": "/tiered-pricing/static-1.2156",
  "topics-actions-lib": "/topics-actions-lib/static-1.600",
  "trial-components-library": "/trial-components-library/static-1.14300",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11341",
  "zustand": "/zustand/static-1.88",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3488",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2901",
  "navigation-components": "/navigation-components/static-1.19077",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1382",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8080",
  "ui-universal-auth": "/ui-universal-auth/static-1.9635",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18595",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.125",
  "opentelemetry-web": "/opentelemetry-web/static-1.20",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10819",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5425",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.14",
  "trellis-theming": "/trellis-theming/static-1.1410",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "audio-components": "/audio-components/static-1.6501",
  "FileManagerCore": "/FileManagerCore/static-1.40256",
  "FileManagerImages": "/FileManagerImages/static-1.37908",
  "video-components": "/video-components/static-1.14347",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1696",
  "purchase-motions-api": "/purchase-motions-api/static-1.6575",
  "signup-constants": "/signup-constants/static-1.19854",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8484",
  "stylex-utils": "/stylex-utils/static-1.164",
  "usage-tracker-public": "/usage-tracker-public/static-1.7550",
  "reactive-lib": "/reactive-lib/static-1.1148",
  "simple-logging-lib": "/simple-logging-lib/static-1.3476",
  "nudge-client-utils": "/nudge-client-utils/static-1.3334",
  "chatspot-core": "/chatspot-core/static-1.23562",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7007",
  "cms-field-types": "/cms-field-types/static-1.5237",
  "content-icons-ui": "/content-icons-ui/static-1.2418",
  "integrations-lib": "/integrations-lib/static-1.17315",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1001",
  "breeze-engine-core": "/breeze-engine-core/static-1.1301",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.89",
  "markdown-it": "/markdown-it/static-1.6",
  "nav-meta": "/nav-meta/static-1.30714",
  "commerce-permissions": "/commerce-permissions/static-1.1204",
  "customer-data-tracking": "/customer-data-tracking/static-1.7297",
  "products-iframe-lib": "/products-iframe-lib/static-1.8817",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11203",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1933",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2765",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.761",
  "calling-error-reporting": "/calling-error-reporting/static-1.31756",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11465",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6959",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2335",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6873",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7222",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10904",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "sales-views-client-types": "/sales-views-client-types/static-1.4683",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10331",
  "bark-lib": "/bark-lib/static-1.16956",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.105",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6313",
  "react-codemirror": "/react-codemirror/static-1.11065",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.436",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4297",
  "persist-promise": "/persist-promise/static-1.4128",
  "event-emitter": "/event-emitter/static-1.1384",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.569",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "data-agent-kit": "/data-agent-kit/static-1.822",
  "fsm": "/fsm/static-1.4180",
  "policy-lib": "/policy-lib/static-1.7230",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10967",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15870",
  "hubs-service-types": "/hubs-service-types/static-1.1690",
  "salesImages": "/salesImages/static-1.682",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2929",
  "user-context-client": "/user-context-client/static-1.4934",
  "nest": "/nest/static-1.661",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1431",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.710",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.64",
  "urlinator": "/urlinator/static-1.4941",
  "video-embed": "/video-embed/static-1.36837",
  "social-insights-client-types": "/social-insights-client-types/static-1.22853",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3091",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3410",
  "whisper-core-api": "/whisper-core-api/static-1.7552",
  "flux-actions": "/flux-actions/static-1.380",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14730",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6036",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8187",
  "redux-observable": "/redux-observable/static-1.78",
  "ReduxMessenger": "/ReduxMessenger/static-2.10796",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.1149",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15762",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8041",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37112",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3839",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16582",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.114",
  "trellis-story-utils": "/trellis-story-utils/static-1.4927",
  "storybook-react": "/storybook-react/static-1.43",
  "academy-common-lib": "/academy-common-lib/static-1.15330",
  "outpost": "/outpost/static-1.4558",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3434",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.677",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1784",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.199",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1245",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.406",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.773",
  "slack-ui-library": "/slack-ui-library/static-1.10822",
  "hub-http-contrib": "/hub-http-contrib/static-1.3453",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5627",
  "academy-service-client": "/academy-service-client/static-1.4118",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.82",
  "SafeStorage": "/SafeStorage/static-1.4818",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7781",
  "wootric-nps": "/wootric-nps/static-1.7271",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19500",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20968",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10963",
  "immutable-less": "/immutable-less/static-1.5075",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18375",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8389",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4341",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8505",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1450",
  "apps-service-types": "/apps-service-types/static-1.4072",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "settings-ui-lib": "/settings-ui-lib/static-1.12955",
  "simple-data-table": "/simple-data-table/static-1.3744"
}
};
